import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const faqs = [
  {
    question: "What is the $80K Tool Trap™ and how do I know if I'm in it?",
    answer: "The $80K Tool Trap™ refers to the average annual waste organizations experience due to redundant marketing technologies, fragmented data, and disconnected tools. You are likely in it if your team struggles to report unified ROI, uses multiple platforms that perform overlapping functions, or if MarkOps and Marketing Strategy are misaligned on tech stack governance."
  },
  {
    question: "How does the SEVEN HATS® platform bridge Marketing Strategy and MarkOps?",
    answer: (
      <>
        SEVEN HATS® Strategic Operations Platform acts as a translation layer between strategy and execution. It maps high-level brand strategy to concrete technical architecture and operational workflows. By establishing shared OKRs and a unified data schema, we ensure that marketing visions are technically feasible and that MarkOps actively supports revenue-generating marketing activities rather than blocking them.
        <br /><br />
        <strong>In practice:</strong> The Tool Trap™ framework (methodology) identifies what needs to change. SEVEN HATS® (platform) provides the structure to implement and maintain those changes systematically.
      </>
    )
  },
  {
    question: "What does an AI Orchestration engagement entail?",
    answer: "Unlike merely buying a new AI tool, AI Orchestration involves weaving intelligent capabilities into your existing workflows. We audit your processes, identify high-friction areas (like content distribution or data analysis), and implement AI loops that automate repetitive tasks, allowing your team to focus strictly on high-leverage strategic initiatives."
  },
  {
    question: "How do fractional leadership services work with my existing team?",
    answer: "As a Fractional CMO, I integrate seamlessly with your current leadership and execution teams. I provide the high-level strategic direction, operational frameworks (like LEAN and OKRs), and executive mentorship needed to elevate your team's output velocity, without the overhead of a full-time executive hire."
  }
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="mb-24">
      <div className="text-center mb-12">
        <span className="text-xs uppercase tracking-widest text-brand-red dark:text-brand-cyan font-bold mb-2 block">AEO & GEO Preparedness</span>
        <h3 className="text-3xl font-heading font-bold text-brand-dark dark:text-white">Frequently Asked Strategic Questions</h3>
      </div>

      <div className="max-w-3xl mx-auto space-y-4">
        {faqs.map((faq, index) => (
          <div key={index} className="border border-slate-200 dark:border-slate-800 rounded-lg bg-white dark:bg-slate-900 overflow-hidden">
            <button
              onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
              className="w-full text-left px-6 py-4 flex items-center justify-between focus:outline-none hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors"
            >
              <span className="font-bold text-brand-dark dark:text-white pr-8">{faq.question}</span>
              <SafeIcon name={openIndex === index ? "ChevronUp" : "ChevronDown"} className="w-5 h-5 text-brand-red dark:text-brand-cyan shrink-0" />
            </button>
            <AnimatePresence>
              {openIndex === index && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  className="overflow-hidden"
                >
                  <div className="px-6 pb-6 pt-2 text-slate-600 dark:text-slate-400 font-medium leading-relaxed border-t border-slate-100 dark:border-slate-800">
                    {faq.answer}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;